import { useSelector } from "react-redux"
import { selectAuthIsAdminRole } from "../../states/auth/auth.selector"

export const useManagementWalletPermission = () => {
   return {
      allowRechargeManagementWallet: useSelector(selectAuthIsAdminRole),
   }
}
